import { BaseDialog } from "./dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';

export default function InvoiceCorrectionCreatePopup({ id, invoiceId, className }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleCreateCorrection = () => {
    setOpen(false);
    navigate(`/admin/invoices/correction/create/${id}`);
  };

  return (
    <BaseDialog
      dialogTitle={`${t('invoices:correction_create_title')}: ${invoiceId}`}
      buttonText={t("invoices:button_create_correction")}
      open={open}
      setOpen={setOpen}
      className={className}
      icon={<EditIcon fontSize="small" className="mr-1" />}
    >
      <div className="max-w-[400px] flex flex-col items-end pt-4">
        <div className="w-full pb-4 text-gray-600">
          {t("invoices:correction_create_title")}
        </div>
        <Button onClick={handleCreateCorrection}>
          {t("invoices:button_create_correction")}
        </Button>
      </div>
    </BaseDialog>
  );
}
